var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicrophoneFilled = function SvgMicrophoneFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.667 8.001V6.668a.667.667 0 0 1 1.333 0v1.333a4 4 0 0 0 8 0V6.668a.667.667 0 0 1 1.334 0v1.333a5.333 5.333 0 0 1-4.667 5.29v.71h2a.667.667 0 0 1 0 1.334H5.334a.667.667 0 1 1 0-1.334h2v-.71a5.333 5.333 0 0 1-4.667-5.29m6.667-4.666a1.333 1.333 0 0 0-2.667 0V8a1.333 1.333 0 0 0 2.667 0zM10.667 8a2.667 2.667 0 0 1-5.333 0V3.335a2.667 2.667 0 0 1 5.333 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 2.001c.737 0 1.334.597 1.334 1.334V8a1.333 1.333 0 0 1-2.667 0V3.335C6.667 2.598 7.264 2 8 2"
  })));
};
export default SvgMicrophoneFilled;